"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const mobx_1 = require("mobx");
const ecommerce_1 = require("../../api/ecommerce");
const array_1 = require("../../common/js/helper/array");
const configuration_1 = __importDefault(require("../apis/configuration/shop/configuration"));
class ShopwareContext {
    api = new ecommerce_1.ContextApi(configuration_1.default);
    currentContext = null;
    loadingCounter = 0;
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            currentContext: mobx_1.observable,
            loadingCounter: mobx_1.observable,
            context: mobx_1.computed,
            currency: mobx_1.computed,
            currentShippingMethod: mobx_1.computed,
            currentPaymentMethod: mobx_1.computed,
            currentShippingAddressId: mobx_1.computed,
            currentBillingAddressId: mobx_1.computed,
            currentShopHomePageId: mobx_1.computed,
            hasContext: mobx_1.computed,
            adyenEnvironment: mobx_1.computed,
            currentShippingMethodService: mobx_1.computed,
            contextExtension: mobx_1.computed,
            customFields: mobx_1.computed,
            isLoading: mobx_1.computed,
            reset: mobx_1.action.bound,
            loadContext: mobx_1.action.bound,
            updateContext: mobx_1.action.bound,
        });
    }
    get context() {
        return this.currentContext;
    }
    get currency() {
        return this.currentContext?.currency ?? null;
    }
    get currentShippingMethod() {
        return this.currentContext?.shippingMethod ?? null;
    }
    get currentPaymentMethod() {
        return this.currentContext?.paymentMethod ?? null;
    }
    get currentShippingAddressId() {
        return this.currentContext?.extensions?.massiveSalesChannelContext?.massiveShippingAddressId ?? undefined;
    }
    get currentBillingAddressId() {
        return this.currentContext?.extensions?.massiveSalesChannelContext?.massiveBillingAddressId ?? undefined;
    }
    get currentShopHomePageId() {
        return this.currentContext?.extensions?.massiveSalesChannelContext?.shopHomePageId ?? null;
    }
    get hasContext() {
        return !!this.currentContext;
    }
    get adyenEnvironment() {
        return this.currentContext?.extensions?.adyenData?.environment ?? null;
    }
    get currentShippingMethodService() {
        const serviceCodeCandidates = [
            this.currentContext?.extensions?.massiveSalesChannelContext?.upsServiceCode,
            this.currentContext?.extensions?.massiveSalesChannelContext?.fedexServiceCode,
        ].filter((serviceCode) => !!serviceCode);
        return serviceCodeCandidates.length ? (0, array_1.first)(serviceCodeCandidates) : null;
    }
    get contextExtension() {
        return this.currentContext?.extensions?.massiveSalesChannelContext ?? null;
    }
    get customFields() {
        return this.currentContext?.salesChannel?.translated?.customFields ?? null;
    }
    get isLoading() {
        return this.loadingCounter > 0;
    }
    initialize() {
        return this.loadContext();
    }
    reset() {
        this.currentContext = null;
    }
    setPaymentMethod(paymentMethodId) {
        return this.updateContext({
            salesChannelContextPatchRequestBody: {
                paymentMethodId,
            },
        });
    }
    setShippingMethod(shippingMethodId, massiveShippingMethodCustomerId) {
        return this.updateContext({
            salesChannelContextPatchRequestBody: {
                shippingMethodId,
                massiveShippingMethodCustomerId,
            },
        });
    }
    setBillingAddress(massiveBillingAddressId) {
        return this.updateContext({
            salesChannelContextPatchRequestBody: {
                massiveBillingAddressId,
            },
        });
    }
    setShippingAddress(massiveShippingAddressId) {
        return this.updateContext({
            salesChannelContextPatchRequestBody: {
                massiveShippingAddressId,
            },
        });
    }
    setAddresses(massiveBillingAddressId, massiveShippingAddressId) {
        return this.updateContext({
            salesChannelContextPatchRequestBody: {
                massiveBillingAddressId,
                massiveShippingAddressId,
            },
        });
    }
    setMassiveShippingMethodCustomerId(massiveShippingMethodCustomerId) {
        return this.updateContext({
            salesChannelContextPatchRequestBody: {
                massiveShippingMethodCustomerId,
            },
        });
    }
    setMassiveResellerId(massiveResellerId) {
        return this.api
            .updateContext({
            salesChannelContextPatchRequestBody: {
                massiveResellerId,
            },
        })
            .then(this.loadContext);
    }
    setMassivePurchaseOrderNumber(massivePurchaseOrderNumber) {
        return this.api
            .updateContext({
            salesChannelContextPatchRequestBody: {
                massivePurchaseOrderNumber,
            },
        })
            .then(this.loadContext);
    }
    setTaxId(taxId) {
        return this.api
            .updateContext({
            salesChannelContextPatchRequestBody: {
                zkpTaxId: taxId,
            },
        })
            .then(this.loadContext)
            .catch((error) => error?.response?.json().then((errorBody) => Promise.reject(errorBody), () => Promise.reject(error)) ?? error);
    }
    setShippingMethodServiceCode(serviceCode, massiveShippingMethodType) {
        const salesChannelContextPatchRequestBody = {
            fedexServiceCode: undefined,
            upsServiceCode: undefined,
        };
        switch (massiveShippingMethodType) {
            case ecommerce_1.ShippingMethodType.FedEx:
                salesChannelContextPatchRequestBody.fedexServiceCode = serviceCode ?? undefined;
                break;
            case ecommerce_1.ShippingMethodType.Ups:
                salesChannelContextPatchRequestBody.upsServiceCode = serviceCode ?? undefined;
                break;
        }
        return this.updateContext({ salesChannelContextPatchRequestBody });
    }
    loadContext() {
        this.loadingCounter++;
        return this.api
            .readContext()
            .then((0, mobx_1.action)((context) => {
            this.currentContext = context;
        }))
            .finally((0, mobx_1.action)(() => this.loadingCounter--));
    }
    updateContext(parameters) {
        this.loadingCounter++;
        return this.api
            .updateContext(parameters)
            .then(this.loadContext)
            .finally((0, mobx_1.action)(() => this.loadingCounter--));
    }
}
__decorate([
    bind_decorator_1.default
], ShopwareContext.prototype, "setAddresses", null);
__decorate([
    bind_decorator_1.default
], ShopwareContext.prototype, "setMassiveShippingMethodCustomerId", null);
__decorate([
    bind_decorator_1.default
], ShopwareContext.prototype, "setMassiveResellerId", null);
__decorate([
    bind_decorator_1.default
], ShopwareContext.prototype, "setMassivePurchaseOrderNumber", null);
__decorate([
    bind_decorator_1.default
], ShopwareContext.prototype, "setTaxId", null);
__decorate([
    bind_decorator_1.default
], ShopwareContext.prototype, "setShippingMethodServiceCode", null);
exports.default = new ShopwareContext();
